const map = {
	"./ship-cargo-critical.png": 3906,
	"./ship-cargo-protection.png": 3324,
	"./ship-cargo.png": 8830,
	"./ship-fishing-critical.png": 4672,
	"./ship-fishing-protection.png": 9986,
	"./ship-fishing.png": 4732,
	"./ship-high-speed-craft-critical.png": 757,
	"./ship-high-speed-craft-protection.png": 3711,
	"./ship-high-speed-craft.png": 2919,
	"./ship-navigation-critical.png": 2966,
	"./ship-navigation-protection.png": 6304,
	"./ship-navigation.png": 9797,
	"./ship-passenger-critical.png": 734,
	"./ship-passenger-protection.png": 1944,
	"./ship-passenger.png": 2490,
	"./ship-pleasure-critical.png": 5131,
	"./ship-pleasure-protection.png": 6213,
	"./ship-pleasure.png": 4389,
	"./ship-tanker-critical.png": 3667,
	"./ship-tanker-protection.png": 8333,
	"./ship-tanker.png": 5213,
	"./ship-tug-special-critical.png": 6200,
	"./ship-tug-special-protection.png": 3978,
	"./ship-tug-special.png": 7108,
	"./ship-unspecified-critical.png": 3389,
	"./ship-unspecified-protection.png": 4167,
	"./ship-unspecified.png": 1455
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;